import { Col } from 'antd';
import React from 'react';
import { UpdateQueryParams } from '@hooks';
import { v3ReportSortOptions } from './ReportSortOptions';

import {
	ReportComponentTypeFilter,
	ReportComponentTypeFilterQueryParams,
	SearchFilter,
	SearchFilterContainer,
	SearchFilterQueryParams,
	SortByFilter,
	SortByFilterQueryParams
} from '../filters';

export type ReportSearchV3QueryParams = ReportComponentTypeFilterQueryParams &
	SortByFilterQueryParams &
	SearchFilterQueryParams;

export interface ReportSearchV3Props {
	onChange: UpdateQueryParams<ReportSearchV3QueryParams>;
	queryParams: ReportSearchV3QueryParams;
}

export const ReportSearchV3: React.FC<ReportSearchV3Props> = ({ onChange, queryParams }) =>
	<SearchFilterContainer>
		<Col span={ 12 }>
			<SearchFilter onChange={ onChange } />
		</Col>
		<Col span={ 12 } />
		<Col span={ 12 }>
			<ReportComponentTypeFilter
				onChange={ onChange }
				selected={ queryParams.componentTypes ?? [] } />
		</Col>
		<Col
			className='align-right'
			span={ 12 }>
			<SortByFilter
				defaultSortOption={ v3ReportSortOptions[ 0 ] }
				onChange={ onChange }
				options={ v3ReportSortOptions }
				queryParams={ queryParams } />
		</Col>
	</SearchFilterContainer>;

